import destroyHtmlTags from './lib/destroyHtmlTags';

function regExEscape(text) {
    return text.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

export default function processExcerptToHtml(excerptText, searchText) {
    excerptText = destroyHtmlTags(excerptText); //Destroy any pre-existing HTML tags to Prevent XSS
    searchText.split(' ').forEach(function (searchTerm) {
        if (searchTerm.length === 0) {
            return; //Prevent search queries that end with space from causing issues.
        }
        const searchPattern = new RegExp(
            '(^|\\W|\\,|\\.|\\(|\\))(' + regExEscape(searchTerm) + ')($|\\W|\\,|\\.|\\(|\\))',
            'ig'
        );
        excerptText = excerptText.replace(searchPattern, '$1<b>$2</b>$3', excerptText);
    });
    return { __html: excerptText };
}
